// extracted by mini-css-extract-plugin
export default {"bicycle":"Bicycle_bicycle__1OfUy"};